import { OPERATION_METHOD } from '~/types/content'

export const isExpectedHttpStatus = (status: number, matchStatus: number): boolean => status === matchStatus

export const isSuccessfulHttpStatus = (status: number): boolean => status >= 200 && status < 300

export const isNetworkError = (status: number): boolean => isExpectedHttpStatus(status, 502) || isExpectedHttpStatus(status, 503) || isExpectedHttpStatus(status, 504)

export const buildOperationHash = ({
  operationId,
  tag,
  method,
  path,
}: {
  operationId?: string,
  tag?: string,
  method?: OPERATION_METHOD,
  path?: string,
}) => {
  const encodedTag = tag ? encodeURIComponent(tag) : 'default'
  const encodedOperationId = operationId
    ? encodeURIComponent(operationId)
    : (method?.toLowerCase() || '') + (path || '').replaceAll(/[\/{}]/g, '_')
  const encodedMethod = method && [OPERATION_METHOD.SUB, OPERATION_METHOD.PUB].includes(method) ? path : encodedOperationId
  return [
    '#',
    encodedTag,
    encodedMethod,
  ].filter(Boolean).join('/')
}

export const defaultMetaHeaders = {
  'User-Agent': 'SwaggerHub Portal',
  'X-Source': 'Portal',
}